/**
 * Created by hao.cheng on 2017/4/13.
 */
import React, { Component } from 'react';
import { Layout } from 'antd';
import { PLATFORM_OEM_URL } from '@/fetch/url'
import { get } from '@/fetch/fetch'
import { withRouter } from 'react-router-dom';
import SiderMenu from './SiderMenu';
import { connect } from 'react-redux';
//import logopng from './pic/logo.png'
import ichonglogopng from './pic/logo-ichong.png'
import xjwllogopng from './pic/logo-xingjiongwulian.png'

const { Sider } = Layout;

class SiderCustom extends Component {

    state = {
        collapsed: false,
        mode: 'inline',
        openKey: '',
        selectedKey: '',
        firstHide: true,        // 点击收缩菜单，第一次隐藏展开子菜单，openMenu时恢复
        menusNew:[],
        logopng:'',
    };

    componentDidMount() {
        let aa = this.props.user.menus;

        let treeData = [];

        if (aa === null || aa === "") {
            return ;
        }

        aa.map(function (item) {
           if (item.pid === 0) {
               let param = new Object();
               param.id = item.id;
               param.key = item.key;
               param.title = item.title;
               param.icon = item.icon;
               param.sub = [];
               treeData.push(param)
           }
        })

        treeData.map(function (item) {
            aa.map(function (item2) {
               if (item2.pid === item.id) {
                   item.sub[item2.sort] = item2;
               }
            })
        })

        this.setState({
            menusNew:treeData ,
        },this.getPlatformOemLogo)
        this.setMenuOpen(this.props)

    }


    getPlatformOemLogo = () => {
        let that = this;

        get(PLATFORM_OEM_URL).then(function (result) {
            if(result.success) {
                let pngurl = '';
                if (result.content.name == 'ichong') {
                    pngurl = ichonglogopng
                } else if (result.content.name == 'xingjiongwulian') {
                    pngurl = xjwllogopng
                }

                that.setState({
                    logopng:pngurl,
                })
            } else {
                that.setState({
                    logopng:'',
                })
            }
        }).catch(function(error){
            that.setState({
                logopng:'',
            })
            console.log(error);
        });
    }

    componentWillReceiveProps(nextProps) {
        console.log(nextProps);
        this.onCollapse(nextProps.collapsed);
        this.setMenuOpen(nextProps)
    }

    setMenuOpen = props => {
        const { pathname } = props.location;
        this.setState({
            openKey: pathname.substr(0, pathname.lastIndexOf('/')),
            selectedKey: pathname
        });
    };
    onCollapse = (collapsed) => {
        console.log(collapsed);
        this.setState({
            collapsed,
            firstHide: collapsed,
            mode: collapsed ? 'vertical' : 'inline',
        });
    };
    menuClick = e => {
        this.setState({
            selectedKey: e.key
        });
        console.log(this.state);
        const { popoverHide } = this.props;     // 响应式布局控制小屏幕点击菜单时隐藏菜单操作
        popoverHide && popoverHide();
    };
    openMenu = v => {
        console.log(v);
        this.setState({
            openKey: v[v.length - 1],
            firstHide: false,
        })
    };
    render() {
        return (
            <Sider
                trigger={null}
                breakpoint="lg"
                collapsed={this.props.collapsed}
                style={{ overflowY: 'auto' }}
            >
                <div className="logo" >
                    <img style={{width:'100%',marginTop: '8px'}} src={this.state.logopng} alt="" />
                </div>
                <SiderMenu
                    menus={this.state.menusNew}
                    onClick={this.menuClick}
                    theme="dark"
                    mode="inline"
                    selectedKeys={[this.state.selectedKey]}
                    openKeys={this.state.firstHide ? null : [this.state.openKey]}
                    onOpenChange={this.openMenu}
                />
                <style>
                    {`
                    #nprogress .spinner{
                        left: ${this.state.collapsed ? '70px' : '206px'};
                        right: 0 !important;
                    }
                    `}
                </style>
            </Sider>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        user:state.user,
    }
}

export default withRouter(connect(mapStateToProps)(SiderCustom));


// WEBPACK FOOTER //
// ./src/components/SiderCustom.jsx